import { TANK_STATUSES } from '../components/clan_quests_constants'

export const clan_supply_progression_progress_mock = () => ({
    regions_unlocked: 7,
    final_region: {
        status: TANK_STATUSES.AVAILABLE,
        price: 5000,
    },
    cheapest_region_price: 3200,
})



// WEBPACK FOOTER //
// ./containers/ClanLanding/mocks/clan_supply_progression_progress_mock.js